var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTitle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377,
    zoomAndPan: "magnify",
    viewBox: "0 0 282.96 56.999996",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "d7b41cd5d2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cea03a1f30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 11.007812 L 282.921875 11.007812 L 282.921875 46.253906 L 0 46.253906 Z M 0 11.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f49e546f21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.621094 11.007812 L 265.800781 11.007812 C 275.535156 11.007812 283.425781 18.898438 283.425781 28.632812 C 283.425781 38.363281 275.535156 46.253906 265.800781 46.253906 L 17.621094 46.253906 C 7.890625 46.253906 0 38.363281 0 28.632812 C 0 18.898438 7.890625 11.007812 17.621094 11.007812 Z M 17.621094 11.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00476074,
    gradientTransform: "matrix(0.137677, 0, 0, 0.137677, -0.000655445, 11.008908)",
    y1: 128,
    x2: 2054.959103,
    gradientUnits: "userSpaceOnUse",
    y2: 128,
    id: "e2ce27944e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 59.199524%, 69.799805%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.192261%, 59.300232%, 69.659424%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.576782%, 59.501648%, 69.381714%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.96283%, 59.70459%, 69.102478%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.347351%, 59.906006%, 68.824768%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.731873%, 60.107422%, 68.545532%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.11792%, 60.310364%, 68.267822%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.502441%, 60.51178%, 67.988586%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.888489%, 60.713196%, 67.710876%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.27301%, 60.916138%, 67.431641%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.659058%, 61.117554%, 67.153931%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.043579%, 61.320496%, 66.876221%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.429626%, 61.521912%, 66.596985%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.814148%, 61.723328%, 66.319275%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.200195%, 61.92627%, 66.040039%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.584717%, 62.127686%, 65.762329%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.970764%, 62.329102%, 65.483093%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.355286%, 62.532043%, 65.205383%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.741333%, 62.733459%, 64.926147%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.125854%, 62.936401%, 64.648438%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.511902%, 63.137817%, 64.369202%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.896423%, 63.339233%, 64.091492%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.282471%, 63.542175%, 63.812256%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.666992%, 63.743591%, 63.534546%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.05304%, 63.945007%, 63.256836%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.437561%, 64.147949%, 62.9776%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.823608%, 64.349365%, 62.69989%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.20813%, 64.552307%, 62.420654%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.592651%, 64.753723%, 62.142944%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.978699%, 64.955139%, 61.863708%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.36322%, 65.158081%, 61.585999%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.749268%, 65.359497%, 61.306763%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.133789%, 65.560913%, 61.029053%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.519836%, 65.763855%, 60.749817%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.904358%, 65.965271%, 60.472107%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.290405%, 66.166687%, 60.194397%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.674927%, 66.369629%, 59.915161%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.060974%, 66.571045%, 59.637451%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.445496%, 66.773987%, 59.358215%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.831543%, 66.975403%, 59.080505%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.216064%, 67.176819%, 58.80127%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.602112%, 67.379761%, 58.52356%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.986633%, 67.581177%, 58.244324%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.372681%, 67.782593%, 57.966614%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.757202%, 67.985535%, 57.687378%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.14325%, 68.186951%, 57.409668%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.527771%, 68.389893%, 57.130432%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.913818%, 68.591309%, 56.852722%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.29834%, 68.792725%, 56.575012%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.684387%, 68.995667%, 56.295776%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.068909%, 69.197083%, 56.018066%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.45343%, 69.398499%, 55.738831%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.839478%, 69.60144%, 55.461121%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.223999%, 69.802856%, 55.181885%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.610046%, 70.005798%, 54.904175%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.994568%, 70.207214%, 54.624939%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.380615%, 70.40863%, 54.347229%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.765137%, 70.611572%, 54.067993%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.151184%, 70.812988%, 53.790283%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.535706%, 71.014404%, 53.512573%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.921753%, 71.217346%, 53.233337%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.306274%, 71.418762%, 52.955627%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.692322%, 71.621704%, 52.676392%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.076843%, 71.82312%, 52.398682%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.462891%, 72.024536%, 52.119446%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.847412%, 72.227478%, 51.841736%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.233459%, 72.428894%, 51.5625%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.617981%, 72.63031%, 51.28479%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.004028%, 72.833252%, 51.005554%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.38855%, 73.034668%, 50.727844%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.774597%, 73.23761%, 50.448608%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.159119%, 73.439026%, 50.170898%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.54364%, 73.640442%, 49.893188%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.929688%, 73.843384%, 49.613953%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.314209%, 74.0448%, 49.336243%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.700256%, 74.246216%, 49.057007%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.084778%, 74.449158%, 48.779297%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.470825%, 74.650574%, 48.500061%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.855347%, 74.85199%, 48.222351%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.241394%, 75.054932%, 47.943115%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.625916%, 75.256348%, 47.665405%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.011963%, 75.45929%, 47.386169%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.396484%, 75.660706%, 47.108459%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.782532%, 75.862122%, 46.83075%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.167053%, 76.065063%, 46.551514%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.553101%, 76.266479%, 46.273804%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.937622%, 76.467896%, 45.994568%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.323669%, 76.670837%, 45.716858%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.708191%, 76.872253%, 45.437622%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.094238%, 77.075195%, 45.159912%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.47876%, 77.276611%, 44.880676%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.864807%, 77.478027%, 44.602966%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.249329%, 77.680969%, 44.32373%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.635376%, 77.882385%, 44.046021%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.019897%, 78.083801%, 43.766785%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.404419%, 78.286743%, 43.489075%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.790466%, 78.488159%, 43.211365%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.174988%, 78.691101%, 42.932129%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.561035%, 78.892517%, 42.654419%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.945557%, 79.093933%, 42.375183%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.331604%, 79.296875%, 42.097473%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.716125%, 79.498291%, 41.818237%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.102173%, 79.699707%, 41.540527%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.486694%, 79.902649%, 41.261292%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.872742%, 80.104065%, 40.983582%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.257263%, 80.307007%, 40.704346%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.643311%, 80.508423%, 40.426636%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.027832%, 80.709839%, 40.148926%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.413879%, 80.912781%, 39.86969%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.798401%, 81.114197%, 39.59198%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.184448%, 81.315613%, 39.312744%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.56897%, 81.518555%, 39.035034%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.955017%, 81.719971%, 38.755798%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.339539%, 81.922913%, 38.478088%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.725586%, 82.124329%, 38.198853%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.110107%, 82.325745%, 37.921143%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.496155%, 82.528687%, 37.641907%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.880676%, 82.730103%, 37.364197%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.265198%, 82.931519%, 37.084961%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.651245%, 83.13446%, 36.807251%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.035767%, 83.335876%, 36.529541%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.421814%, 83.537292%, 36.250305%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.806335%, 83.740234%, 35.972595%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.192383%, 83.94165%, 35.693359%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.576904%, 84.144592%, 35.415649%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.962952%, 84.346008%, 35.136414%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.347473%, 84.547424%, 34.858704%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.733521%, 84.750366%, 34.579468%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.118042%, 84.951782%, 34.301758%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b4b7b0e960"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d7b41cd5d2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.296,
    width: 339.552,
    fill: "#000000",
    y: -5.7,
    height: 68.399996,
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c189aa8eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.804688 1.007812 L 33 1.007812 L 33 36.253906 L 0.804688 36.253906 Z M 0.804688 1.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b5955397a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 1.007812 L 59 1.007812 L 59 36.253906 L 27 36.253906 Z M 27 1.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8aa2ddea31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 1.007812 L 86 1.007812 L 86 36.253906 L 54 36.253906 Z M 54 1.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "055d252e46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 87,
    y: 0,
    height: 37
  })), /*#__PURE__*/React.createElement("mask", {
    id: "08b78d8ef9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d7b41cd5d2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.296,
    width: 339.552,
    fill: "#000000",
    y: -5.7,
    height: 68.399996,
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "391e7690df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.976562 1.007812 L 33 1.007812 L 33 36.253906 L 0.976562 36.253906 Z M 0.976562 1.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bea7faf6e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 1.007812 L 60 1.007812 L 60 36.253906 L 27 36.253906 Z M 27 1.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "62fcaa906a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 1.007812 L 86.464844 1.007812 L 86.464844 36.253906 L 54 36.253906 Z M 54 1.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53c865ca27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 87,
    y: 0,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cea03a1f30)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f49e546f21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e2ce27944e)",
    d: "M 0 11.007812 L 0 46.253906 L 282.921875 46.253906 L 282.921875 11.007812 Z M 0 11.007812 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b4b7b0e960)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 172, 10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#055d252e46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c189aa8eb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#109c59",
    d: "M 32.019531 18.632812 L 25.199219 11.777344 L 25.164062 11.8125 L 14.4375 1.050781 L 0.804688 1.128906 L 18.34375 18.632812 L 0.804688 36.136719 L 14.4375 36.210938 L 25.164062 25.449219 L 25.199219 25.488281 Z M 32.019531 18.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b5955397a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#109c59",
    d: "M 58.984375 18.632812 L 52.164062 11.777344 L 52.128906 11.8125 L 41.402344 1.050781 L 27.804688 1.128906 L 45.308594 18.632812 L 27.804688 36.136719 L 41.402344 36.210938 L 52.128906 25.449219 L 52.164062 25.488281 Z M 58.984375 18.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8aa2ddea31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#109c59",
    d: "M 85.984375 18.632812 L 79.128906 11.777344 L 79.128906 11.8125 L 68.40625 1.050781 L 54.769531 1.128906 L 72.273438 18.632812 L 54.769531 36.136719 L 68.40625 36.210938 L 79.128906 25.449219 L 79.128906 25.488281 L 85.984375 18.632812 L 85.949219 18.632812 Z M 85.984375 18.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#08b78d8ef9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 48, 10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53c865ca27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#391e7690df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#109c59",
    d: "M 32.191406 18.632812 L 25.375 11.777344 L 25.335938 11.8125 L 14.613281 1.050781 L 0.976562 1.128906 L 18.519531 18.632812 L 0.976562 36.136719 L 14.613281 36.210938 L 25.335938 25.449219 L 25.375 25.488281 Z M 32.191406 18.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bea7faf6e8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#109c59",
    d: "M 59.15625 18.632812 L 52.339844 11.777344 L 52.300781 11.8125 L 41.578125 1.050781 L 27.980469 1.128906 L 45.484375 18.632812 L 27.980469 36.136719 L 41.578125 36.210938 L 52.300781 25.449219 L 52.339844 25.488281 Z M 59.15625 18.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#62fcaa906a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#109c59",
    d: "M 86.160156 18.632812 L 79.304688 11.777344 L 79.304688 11.8125 L 68.578125 1.050781 L 54.945312 1.128906 L 72.449219 18.632812 L 54.945312 36.136719 L 68.578125 36.210938 L 79.304688 25.449219 L 79.304688 25.488281 L 86.160156 18.632812 L 86.121094 18.632812 Z M 86.160156 18.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTitle3);
export default __webpack_public_path__ + "static/media/bg-title_3.6fb3b57c6a84a61bf63a97e74b157bd9.svg";
export { ForwardRef as ReactComponent };